import { render } from "./AddNewItem.vue?vue&type=template&id=36df5ffe"
import script from "./AddNewItem.vue?vue&type=script&lang=js"
export * from "./AddNewItem.vue?vue&type=script&lang=js"

import "./AddNewItem.vue?vue&type=style&index=0&id=36df5ffe&lang=css"

import exportComponent from "D:\\courses\\Web Design\\JAVA  SCRIPT\\Vue-js courses\\resturant\\mat-aem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__